import { Box } from '@mui/material';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid-pro';

import { PanelGrid } from 'components/grid';
import { SubTitle } from 'components/text';
import { QueryProdutoReembolso, useQueryProdutoReembolso } from 'pages/financeiro/reembolso/consulta-reembolso/hooks';
import { ProdutoReembolso } from 'pages/financeiro/reembolso/consulta-reembolso/types';
import { brlDecimal, brlPrice } from 'util/format';

/**
 * Retorna array com os dados formatados para o grid.
 */
const getRows = (data?: ProdutoReembolso[]): GridRowsProp => {
    const list = data;

    if (Array.isArray(list) && list.length) {
        return list.map((item, index) => ({
            id: index,
            cdProduto: item.cdProduto,
            dsProduto: item.dsProduto,
            cdApuracao: item.cdApuracao,
            idPromocao: item.idPromocao,
            dsPromocao: item.dsPromocao,
            fgReembolso: item.fgReembolso,
            qtProduto: item.qtProduto,
            vlTotalBruto: item.vlTotalBruto,
            vlDesconto: item.vlDesconto,
            vlDescontoManual: item.vlDescontoManual,
            vlTotalLiquido: item.vlTotalLiquido,
            peDesconto: item.peDesconto,
            peReembolso: item.peReembolso,
            vlReembolso: item.vlReembolso,
        }));
    }

    return [];
};

const columns: GridColDef[] = [
    {
        field: 'cdProduto',
        headerName: 'Código produto',
        width: 100,
    },
    {
        field: 'dsProduto',
        headerName: 'Descrição',
        flex: 1,
        minWidth: 90,
    },
    {
        field: 'cdApuracao',
        headerName: 'Código da apuração',
        width: 90,
    },
    {
        field: 'idPromocao',
        headerName: 'Código promoção',
        width: 80,
    },
    {
        field: 'dsPromocao',
        headerName: 'Promoção/campanha',
        flex: 1,
        minWidth: 140,
    },
    {
        field: 'fgReembolso',
        align: 'center',
        headerName: 'Promoção reembolsável',
        width: 90,
        valueFormatter: (value) => (value ? 'Sim' : 'Não'),
    },
    {
        field: 'qtProduto',
        headerName: 'Quantidade',
        type: 'number',
        width: 90,
        valueFormatter: (value) => brlDecimal(value),
    },
    {
        field: 'vlTotalBruto',
        headerName: 'Total bruto',
        type: 'number',
        width: 100,
        valueFormatter: (value) => brlPrice(value),
    },
    {
        field: 'vlDesconto',
        headerName: 'Desconto item',
        type: 'number',
        width: 100,
        valueFormatter: (value) => brlPrice(value),
    },
    {
        field: 'vlDescontoManual',
        headerName: 'Desconto manual',
        type: 'number',
        width: 100,
        valueFormatter: (value) => brlPrice(value),
    },
    {
        field: 'vlTotalLiquido',
        headerName: 'Total líquido',
        type: 'number',
        width: 100,
        valueFormatter: (value) => brlPrice(value),
    },
    {
        field: 'peReembolso',
        headerName: 'Fator reembolso',
        type: 'number',
        width: 100,
        valueFormatter: (value) => `${brlDecimal(value)}%`,
    },
    {
        field: 'vlReembolso',
        headerName: 'Valor reembolso',
        type: 'number',
        width: 100,
        valueFormatter: (value) => brlPrice(value),
    },
];

export function ConsultaReembolsoProdutoGrid({ nrNota, dsSerie, cdLoja }: QueryProdutoReembolso) {
    const { data, refetch, isFetching } = useQueryProdutoReembolso({ nrNota, dsSerie, cdLoja });

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', p: 2 }}>
            <SubTitle label="Lista de Produtos" />

            <PanelGrid
                rows={getRows(data?.data)}
                rowsCount={data?.total ?? 0}
                reload={refetch}
                columns={columns}
                loading={isFetching}
                summary={['vlTotalBruto', 'vlDesconto', 'vlDescontoManual', 'vlTotalLiquido', 'vlReembolso']}
            />
        </Box>
    );
}
